import { Component, OnInit } from '@angular/core';
import { SchoolModule } from '../../appshared/masters/school/school.module';
import { MatTableDataSource } from '@angular/material/table';
import { SchoolService } from '../../appshared/Main/school/school.service';

@Component({
  selector: 'app-schools',
  templateUrl: './schools.component.html',
  styleUrls: ['./schools.component.scss']
})
export class SchoolsComponent implements OnInit {
    isLoading = true;
    public schools: SchoolModule[] = [];
    constructor(private service: SchoolService,) { }

    ngOnInit(): void {
        this.getAllService();
  }

    public getAllService = () => {
        this.isLoading = true;
        this.schools = [];
        this.service.getService()
            .subscribe(res => {
                this.schools = res as SchoolModule[];
            })
        this.isLoading = false;
    }
}
